/**
 * Draws the exhibit's checkmark once the card itself has been revealed —
 * reveal.ts announces that with `goodface:revealed`, so this never runs its
 * own scroll observer. Skipped for `prefers-reduced-motion` and safe with no
 * JavaScript at all: the resting stroke is fully painted until this runs.
 */
import { reducedMotion } from '../../src/js/utils/motion';

const setup = (exhibit: HTMLElement): void => {
  const check = exhibit.querySelector<SVGPathElement>('[data-course-hero-check] path');

  if (!check || reducedMotion()) {
    return;
  }

  const length = check.getTotalLength();

  check.style.strokeDasharray = `${length}`;
  check.style.strokeDashoffset = `${length}`;

  const draw = (): void => {
    check.animate(
      { strokeDashoffset: [`${length}`, '0'] },
      { duration: 500, easing: 'ease-in-out', fill: 'forwards' }
    );
  };

  if (exhibit.classList.contains('is-revealed')) {
    draw();
    return;
  }

  exhibit.addEventListener('goodface:revealed', draw, { once: true });
};

const init = (): void => {
  document
    .querySelectorAll<HTMLElement>('.course-hero__exhibit[data-reveal]')
    .forEach(setup);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

export {};
